import React, { useContext, useState } from "react";
import { useMutation } from "@tanstack/react-query";

import { refetchBasketData } from "../queries/global";
import {
  NotificationContext,
  handleError,
} from "../context/NotificationContext";

import config from "../config/config";
import * as QUERIES from "../queries/query-functions";

import LoadingIndicator from "../components/loading-indicator";
import OptionsImage from "../components/options-image";

const upsell_data = config.OPTION_FIELDS.additional_donation_upsell;
const fundId = upsell_data?.fund;
const amounts = upsell_data?.suggested_amounts?.length
  ? upsell_data.suggested_amounts.sort((a, b) => a.amount - b.amount)
  : null;

export default function AdditionalDonation(props) {
  const { notification, setNotification } = useContext(NotificationContext);
  const [selectedAmount, setSelectedAmount] = useState(null);

  const addDonation = useMutation({
    mutationFn: () =>
      QUERIES.addDonation([{ Amount: selectedAmount, FundId: fundId }]),
    onError: (error) => {
      handleError(error.message, setNotification);
    },
    onSuccess: (data) => {
      refetchBasketData();
    },
  });

  if (!upsell_data || !fundId || !amounts) return null;

  return (
    <div className="booking-pathway__additional-donation">
      <h1 className="booking-pathway__header">
        {upsell_data?.title ? upsell_data.title : "Support us"}
      </h1>

      <article className="extras-instance extras-instance__additional-donation stack">
        {upsell_data?.image && (
          <div className="extras-instance__image">
            <OptionsImage image={upsell_data.image} />
          </div>
        )}

        {upsell_data?.introduction && (
          <div
            className="extras-instance__summary"
            dangerouslySetInnerHTML={{ __html: upsell_data.introduction }}
          ></div>
        )}

        <div className="extras-instance__footer">
          <p className="sr-only">Select an amount to donate</p>
          <div className="extras-instance__buttons">
            {amounts.map((amount) => (
              <button
                key={amount.amount}
                type="button"
                className={`btn booking-pathway__additional-donation--amount ${
                  amount.amount == selectedAmount ? "active" : ""
                }`}
                onClick={() => setSelectedAmount(amount.amount)}
              >
                £{amount.amount}
              </button>
            ))}
          </div>
          {selectedAmount ? (
            <button
              type="button"
              disabled={addDonation.isPending}
              className="booking-pathway__additional-donation--button btn btn--primary"
              onClick={() => addDonation.mutateAsync()}
            >
              Add donation to basket
              {addDonation.isPending && <LoadingIndicator />}
            </button>
          ) : (
            <p
              className="booking-pathway__additional-donation--button btn btn--primary disabled"
              aria-label="Choose a donation amount to add to the basket"
            >
              Add donation to basket
            </p>
          )}
        </div>
      </article>
    </div>
  );
}
